module.exports = __webpack_public_path__ + "img/10.ee9612c0.jpg";